module.exports = __webpack_public_path__ + "f7ec760a1f81bb2abb7417eecb70b538.jpg";